module.exports = Jsw.skinUrl + "/images/sticker-collection/sticker/skateboard.png?64400e56849df5f58cf2c8ee69d951d4";